export const getAuthProviderRedirectUrl = (): string => {
  const { VUE_APP_DIGI_USERS_F } = process.env;
  const path = window.location.pathname;
  const query = window.location.search;
  const redirect = encodeURIComponent(`${path}${query}`);

  return `${VUE_APP_DIGI_USERS_F}/auth/provider?app=contextify&redirect=${redirect}`;
};

export const getSubscriptionRedirectUrl = (): string => {
  const { VUE_APP_DG_SUBS } = process.env;
  const token = localStorage.getItem('token');
  const url = `${VUE_APP_DG_SUBS}/auth/confirmsession?token=${token}&redirect=/app/services/contextify`;
  return url;
};
